import React from 'react';

/**
 * The component used to represent an empty page that is hidden because the required feature is not enabled.
 */
export class HiddenFeature extends React.Component {
  render() {
    return (
      <h1 id="hide-display">Feature Coming Soon</h1>
    );
  }
}



// WEBPACK FOOTER //
// src/features/hidden-feature.component.js